// 知识库数据类型定义

export const NodeType = {
  FOLDER: 'folder',
  DOCUMENT: 'document'
}

export const CanvasComponentType = {
  DIRECTORY: 'directory',
  DOCUMENT: 'document',
  SHORTCUT: 'shortcut'
}

// ---- 工厂函数 ----

export function createWorkspace(name = '默认工作空间') {
  const now = new Date().toISOString()
  return {
    workspace_id: `ws_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    name,
    owner_id: null,
    team_id: null,
    created_at: now,
    updated_at: now,
    settings: {
      default_expand_depth: 2,
      theme: 'default'
    }
  }
}

export function createDirectoryNode(workspaceId, parentId, name, type = NodeType.FOLDER, order = 0) {
  const now = new Date().toISOString()
  return {
    node_id: `node_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    workspace_id: workspaceId,
    parent_id: parentId,
    name,
    type,
    order,
    is_expanded: false,
    created_at: now,
    updated_at: now
  }
}

export function createDocument(nodeId, workspaceId, title = '未命名文档') {
  const now = new Date().toISOString()
  return {
    document_id: `doc_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    node_id: nodeId,
    workspace_id: workspaceId,
    title,
    content_html: '',
    content_md: '',
    created_by: null,
    created_at: now,
    updated_at: now,
    version: 1
  }
}

export function createCanvasComponent(workspaceId, type, options = {}) {
  const now = new Date().toISOString()
  return {
    component_id: `comp_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    workspace_id: workspaceId,
    type,
    node_id: options.node_id || null,
    document_id: options.document_id || null,
    shortcut_node_id: options.shortcut_node_id || null,
    position: options.position || { x: 100, y: 100 },
    size: options.size || { width: 300, height: 400 },
    z_index: options.z_index || 1,
    is_minimized: options.is_minimized || false,
    is_visible: true,
    created_at: now,
    updated_at: now
  }
}

export function createCanvasViewState(workspaceId) {
  return {
    workspace_id: workspaceId,
    zoom: 1,
    pan: { x: 0, y: 0 },
    last_updated: new Date().toISOString()
  }
}
